import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import './../styles/Favourites.scss';
import useUserStore from '../store/userStore'; 
import { useLoadingStore } from '../store/loadingStore';
import useToastStore from '../store/toastStore';
import { useNavigate } from 'react-router-dom';
import useFavouriteStore from '../store/favouriteStore';
import useCartStore from '../store/cartStore';
import { Favourite, toCartItemDTO } from '../types/Favourite';

const Favourites = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useUserStore(); 
  const { setLoading } = useLoadingStore();
  const { favourites, removeFavourite, getUserFavourites } = useFavouriteStore();
  const { addToCart } = useCartStore();
  const { showToast } = useToastStore();
  const [quantities, setQuantities] = useState<Record<string, number>>({});

  const handleRemoveItem = async (id: string) => {
    setLoading(true);
    try {
      await removeFavourite(id);
      showToast('Removed product from favourites!', 'success');
      await getUserFavourites();
    } catch (error) {
      showToast('Error removing product from favourites!', 'error');
    }
    setLoading(false);
  };

  const handleQuantityChange = (sku: string, change: number) => {
    setQuantities(prev => {
      const currentQuantity = prev[sku] || 1;
      const newQuantity = currentQuantity + change;
      return {
        ...prev,
        [sku]: newQuantity > 1 ? newQuantity : 1
      };
    });
  };

  const handleAddToCart = async (fav: Favourite) => {
    setLoading(true);
    try {
      const cartItemDTO = toCartItemDTO(fav);
      cartItemDTO.quantity = quantities[fav.sku] || 1;
      await addToCart(cartItemDTO);
      showToast('Added to cart successfully!', 'success');
    } catch (error) {
      showToast('Error adding to cart!', 'error');
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchFavourites = async () => {
      await getUserFavourites();
    }
    fetchFavourites();
  }, [user, getUserFavourites]);

  return (
    <div className="favourites-container">
      <h2>My Favourites ({favourites.length})</h2>
      
      {favourites.length > 0 ? (
        <div className="favourites-list">
          {favourites.map((item) => (
            <div key={item.sku} className="list-view">
              <img
                src={item.image}
                alt={item.name}
                className="image"
                onClick={() => navigate(`/product/${item.sku}`)}
              />
              <div className="details">
                <h3>{item.name}</h3>
                <p>SKU: {item.sku}</p>
              </div>
              <div className="prices">
                  <span className="b2c-price">{item.price?.toFixed(2)}€</span>
              </div>
              {/* <div className={`status ${item.status?.replace(/\s+/g, '-').toLowerCase()}`}>
                {item.status}
              </div> */}
              <div className="cartCol">
                <div className="quant">Quantity</div>
                <div className="addCart">
                  <div className="quantity-controls">
                    <button
                      className="quanBtn"
                      onClick={() => handleQuantityChange(item.sku, -1)}
                    >
                      -
                    </button>
                    <span>{quantities[item.sku] || 1}</span>
                    <button
                      className="quanBtn"
                      onClick={() => handleQuantityChange(item.sku, 1)}
                    >
                      +
                    </button>
                  </div>
                  <button
                    className="add-to-cart"
                    disabled={!isAuthenticated && item.price != null}
                    onClick={() => handleAddToCart(item)}
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
              <div className="actions">
                <button
                  className="remove-btn"
                  onClick={() => handleRemoveItem(item.id)}
                >
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="empty-message">Your favourites list is empty.</p>
      )}
    </div>
  );
};

export default Favourites;